import { render, staticRenderFns } from "./terra-list.vue?vue&type=template&id=c01ceefa"
import script from "./terra-list.vue?vue&type=script&lang=js"
export * from "./terra-list.vue?vue&type=script&lang=js"
import style0 from "./terra-list.vue?vue&type=style&index=0&id=c01ceefa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports